import { queryHooks } from "../../graphql";

const useShouldShowPrice = () => {
	return queryHooks.useGetShouldShowPricesQuery();
}

export {useShouldShowPrice};